module.exports = __webpack_public_path__ + "img/chad.6db85742.jpg";